
import permissions from '../constants/permissions'
import envConfig from '../envConfig'
import { getAppUrl, getVersionUrl } from '../helpers/microApps/buildUrls'
import PermissionsUtil from '../helpers/permissions/PermissionsUtil'
import { isFeatureAllowed, combinePathsWithEnv } from '../helpers/routeUtil'
import Locations from '../helpers/tools/locations'
import { MicroApp } from '../types/microApp'

const microAppUrl = envConfig.apps.paymentsSearch

const App: MicroApp = {
  name: 'payments_search',
  importFunction: async (version: string) => (
    System.import(getAppUrl(microAppUrl, version))
  ),
  getVersion: async (): Promise<string> => {
    const version = await System.import(getVersionUrl(microAppUrl))
    return version.default
  },
  permissionsCheck: (): boolean => {
    const requiredPermissions = [
      permissions.payments.get
    ]
    return isFeatureAllowed(PermissionsUtil.all, requiredPermissions)
  },
  paths: combinePathsWithEnv([Locations.paymentsSearch])
}

export default App
